const INITIAL_STATE = {
  step: 1,
  condominiumName: null,
  externalCondominiumId: null,
  externalBlockId: null,
  externalUnitId: null,
  unitInstanceId: null,
  name: null,
  deliveryType: null,
  dueDay: null,
  hasGasMeter: null,
  address: {
    fullAddress: null,
    address: null,
    number: null,
    complement: null,
    neighborhood: null,
    city: null,
    stateCode: null,
    zipCode: null,
    addressType: null
  },
  addressShipLetterTo: {
    fullAddress: null,
    address: null,
    number: null,
    complement: null,
    neighborhood: null,
    city: null,
    stateCode: null,
    zipCode: null,
    addressType: null
  }
};

const addNewUnitReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;
  const reducer = {
    TOGGLE_NEW_UNIT_STEP: () => ({ ...state, step: action.step }),
    NEW_UNIT_VALUES: () => ({ ...state, ...action.object }),
    RESET_STATE_NEW_UNIT: () => ({ ...state, ...INITIAL_STATE })
  };

  return reducer[type] ? reducer[type]() : { ...state };
};

export default addNewUnitReducer;
